<template>
  <div class="" id="register">
    <b-container class="register-form-container" fluid>
      <div
        class="videoBgRegister"
        :style="{ minHeight: registerTotalH + 'px' }"
      >
        <client-only>
          <div
            class="bannerVideo embed-responsive embed-responsive-16by9"
            :style="{ minHeight: registerTotalH + 'px' }"
          >
            <video
              autoplay
              muted
              loop
              class="embed-responsive-item"
              allowfullscreen
              alt="Ariel drone shot of city scape."
              playsinline
            >
              <source src="/img/Footer_video.mp4" type="video/mp4" />
              Sorry, your browser doesn't support embedded videos.
            </video>
          </div>
        </client-only>
      </div>

      <b-row>
        <b-col cols="12" md="6" class="d-flex justify-content-center">
          <img
            src="/img/SOUTHBAY_LOGO_BLUE.svg"
            alt="Southbay Logo"
            class="southbay-logo img-fluid max-w-400"
          />
        </b-col>
        <b-col cols="12" md="6" class="">
          <b-form
            id="southbayRegForm"
            method="post"
            @submit.prevent="submitForm"
            class="reg-form max-w-800 mx-auto"
          >
            <b-row>
              <b-col class="">
                <b-form-group
                  label="FIRST NAME"
                  label-for="regFnName"
                  label-sr-only
                >
                  <b-form-input
                    id="regFnName"
                    type="text"
                    v-model="form.firstname"
                    placeholder="FIRST NAME *"
                    aria-label="FIRST NAME (required)"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-form-group
                  label="LAST NAME"
                  label-for="regLnName"
                  label-sr-only
                >
                  <b-form-input
                    id="regLnName"
                    type="text"
                    v-model="form.lastname"
                    placeholder="LAST NAME *"
                    aria-label="LAST NAME (required)"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-form-group label="CITY" label-for="regCITY" label-sr-only>
                  <b-form-input
                    id="regCITY"
                    type="text"
                    v-model="form.city"
                    placeholder="CITY"
                    aria-label="CITY"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-form-group
                  label="POSTAL CODE"
                  label-for="regPCODE"
                  label-sr-only
                >
                  <b-form-input
                    id="regPCODE"
                    type="text"
                    v-model="form.postal"
                    placeholder="POSTAL CODE"
                    aria-label="POSTAL CODE"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-form-group
                  label="PHONE NUMBER"
                  label-for="regPHONE"
                  label-sr-only
                >
                  <b-form-input
                    id="regPHONE"
                    type="text"
                    v-model="form.phone"
                    placeholder="PHONE NUMBER *"
                    aria-label="PHONE NUMBER"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="">
                <b-form-group label="EMAIL" label-for="regEMAIL" label-sr-only>
                  <b-form-input
                    id="regEMAIL"
                    type="email"
                    v-model="form.email"
                    placeholder="EMAIL *"
                    aria-label="EMAIL (required)"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="10" md="12" class="">
                <b-form-group
                  label="How DID You Hear About Us?"
                  label-for="regHearAbout"
                  label-sr-only
                >
                  <b-form-select
                    id="regHearAbout"
                    type="text"
                    v-model="form.howDidYouHearAboutUs"
                    :options="optionsAboutYou"
                    :class="{
                      hasValue: form.howDidYouHearAboutUs,
                    }"
                    aria-label="Select How DID You Hear About Us (required)"
                    required
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- ARE YOU WORKING WITH AN AGENT? -->
            <b-form-group
              id="agent-radio"
              label="ARE YOU A REALTOR?"
              label-sr-only
            >
              <b-row>
                <b-col cols="8">
                  <div class="headerReg">ARE YOU A REALTOR?</div>
                </b-col>
                <b-col cols="2">
                  <label id="YES" class="radioOption" for="YES" label-sr-only
                    >YES</label
                  >
                  <b-form-radio
                    v-model="form.Areyouabroker"
                    name="agent-radios"
                    value="YES"
                    title="YES, REALTOR"
                    aria-label="YES, REALTOR"
                    >YES</b-form-radio
                  >
                </b-col>
                <b-col cols="2">
                  <label id="NO" class="radioOption" for="NO" label-sr-only
                    >NO</label
                  >
                  <b-form-radio
                    v-model="form.Areyouabroker"
                    name="agent-radios"
                    value="NO"
                    title="NO, not REALTOR"
                    aria-label="NO, not REALTOR"
                    >NO</b-form-radio
                  >
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group
              v-if="form.Areyouabroker == 'YES'"
              id="regAgentName2"
              label=""
              label-for="regAgentName"
            >
              <b-form-input
                id="regAgentName"
                type="text"
                v-model="form.brokerageName"
                placeholder="BROKERAGE NAME *"
                :required="form.Areyouabroker == 'YES'"
                aria-label="If you are a realtor, please give us your realtor name"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="agent-radio-working"
              label="ARE YOU WORKING WITH AN AGENT?"
              label-sr-only
            >
              <b-row>
                <b-col cols="8">
                  <div class="headerReg">ARE YOU WORKING WITH AN AGENT?</div>
                </b-col>
                <b-col cols="2">
                  <label id="YES2" class="radioOption" for="YES2" label-sr-only
                    >YES</label
                  >
                  <b-form-radio
                    v-model="form.workingWithAgent"
                    name="agent-radios-working"
                    value="YES"
                    title="YES, WORKING WITH AN AGENT?"
                    aria-label="YES, WORKING WITH AN AGENT?"
                    >YES</b-form-radio
                  >
                </b-col>
                <b-col cols="2">
                  <label id="NO2" class="radioOption" for="NO2" label-sr-only
                    >NO</label
                  >
                  <b-form-radio
                    v-model="form.workingWithAgent"
                    name="agent-radios-working"
                    value="NO"
                    title="NO, NOT WORKING WITH AN AGENT?"
                    aria-label="NO, NOT WORKING WITH AN AGENT?"
                    >NO</b-form-radio
                  >
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group>
              <b-button
                type="submit"
                class="reg-submit"
                aria-label="Submit Button"
                >REGISTER TODAY</b-button
              >
            </b-form-group>
            <p class="lato-regular text-blue reg-text w-70">
              By completing this registration form I am providing consent to
              receive emails and other electronic messages from Fernbrook Homes
              or Zancor Homes, and understand that I can withdraw my consent at
              any time in the future.
            </p>
            <div class="pt-2">
              <img
                src="/img/FERNBROOK_BLUE.svg"
                alt="Southbay Logo"
                class="img-fluid max-w-100 mr-4"
              />
              <img
                src="/img/ZANCOR_BLUE.svg"
                alt="Southbay Logo"
                class="img-fluid max-w-100"
              />
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import jq from 'jquery';
export default {
  data() {
    return {
      registerH: null,
      registerTotalH: null,
      form: {
                firstname: null,
                lastname: null,
                email: null,
                city: null,
                postal: null,
                phone: null,
                howDidYouHearAboutUs: null,
                Areyouabroker: "NO",
                brokerageName: null,
                workingWithAgent: null,
            },
      optionsAboutYou: [
        {
          value: null,
          text: "HOW DID YOU HEAR ABOUT US?",
          disabled: true,
        },
        {
          value: "Friend",
          text: "Friend",
        },
        {
          value: "Realtor",
          text: "Realtor",
        },
        {
          value: "Mailer",
          text: "Mailer",
        },
        {
          value: "Google Ad",
          text: "Google Ad",
        },
        {
          value: "Twitter",
          text: "Twitter",
        },
        {
          value: "Facebook",
          text: "Facebook",
        },
        {
          value: "Website",
          text: "Website",
        },
        {
          value: "Signage",
          text: "Signage",
        },
        {
          value: "Buzz Buzz Home",
          text: "Buzz Buzz Home",
        },
        {
          value: "Homes Magazine",
          text: "Homes Magazine",
        },
        {
          value: "Other",
          text: "Other",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getMidHeight();
      jq(window).on("resize", () => {
        this.getMidHeight();
        setTimeout(() => {
          this.getMidDomHeight();
        }, 500);
      });
      setTimeout(() => {
        this.getMidDomHeight();
      }, 100);
    });
  },
  methods: {
    getMidHeight() {
      this.registerH = jq(window).height();
    },
    getMidDomHeight() {
      this.registerTotalH = jq("#register").height();
    },
            submitForm () {
            let form = this.form;
            let _this = this;

            console.log(this.form)

          jq.ajax({
                method: "POST",
                url: "/php/southbay-register.php",
                crossDomain: true,
                data: {
                    firstname: form.firstname,
                    lastname: form.lastname,
                    email: form.email,
                    city: form.city,
                    postal: form.postal,
                    phone: form.phone,
                    howDidYouHearAboutUs: form.howDidYouHearAboutUs,
                    Areyouabroker: form.Areyouabroker,
                    brokerageName: form.brokerageName,
                    workingWithAgent: form.workingWithAgent,
                },
            }).done(function (msg) {
                if (msg) {
                    _this.$router.push("/thankyou");
                    console.log(msg)
                }
            });
        }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables";
#register {
  background-color: $m-cream;
  overflow: hidden;
  .register-form-container {
    padding: 100px 0px 100px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    @media screen and (max-width: 500px) {
      padding: 50px 20px 50px 20px;
    }
    .videoBgRegister {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      video {
        object-fit: cover;
        background-color: $m-cream;
      }
    }
    .southbay-logo {
      @media screen and (max-width: 500px) {
        max-width: 250px;
      }
    }
    .reg-form {
      margin-top: 40px;
      padding: 0px 100px 0px 100px;
      @media screen and (max-width: 1200px) {
        padding: 0px 50px 0px 50px;
      }
      @media screen and (max-width: 500px) {
        padding: 0px 0px 0px 0px;
      }
      .desktop {
        position: relative;
        padding-top: 15px;
        .reg-submit {
          background-color: #0b2340;
          color: white;
          border: 1px solid #0b2340;
          width: 100%;
          padding: 10px;
          @media screen and (max-width: 990px) {
            top: 5px;
          }
        }
      }
      .reg-submit-container {
        position: relative;
        padding-top: 10px;
        .reg-submit {
          background-color: #0b2340;
          color: white;
          border: 1px solid #0b2340;
          width: 100%;
          padding: 10px;
        }
      }
      .reg-text {
        font-size: 10px;
        font-weight: 600;
        line-height: 10px;
        padding-top: 10px;
      }
    }
  }
}
</style>

<style lang="scss">
@import "./assets/styles/variables";

#register {
  .register-form-container {
    .custom-control-label {
      color: #0b2340;
    }
    .form-control,
    .custom-select {
      height: calc(1.5em + 0.8rem + 2px);
      border-radius: 0;
      background-color: white;
      opacity: 0.9;
      color: #0b2340;
      font-size: 1rem;
      font-family: "lato", sans-serif;
      font-weight: 400;
      font-style: normal;
      padding-left: 20px;
    }
    .discription {
      font-size: 18px;
      text-align: left;
    }
    button[type="submit"] {
      border-radius: 0;
      font-family: "lato", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 1rem;
      border: none;
      padding: 10px 30px;
      text-align: center;
      background-color: #0b2340;
      color: white;
      width: 70%;
    }
    #agent-radio {
      // background-color: #fff;
      .headerReg {
        font-size: 1rem;
        // padding: 0px;
        text-align: left;
        color: #0b2340;
        font-family: "lato", sans-serif;
        font-weight: 400;
        font-style: normal;
      }
    }
    #regAgentName2 {
      font-size: 1rem;
      color: #0b2340;
    }
    #agent-radio-working {
      // background-color: #fff;
      .headerReg {
        font-size: 1rem;
        text-align: left;
        color: #0b2340;
        font-family: "lato", sans-serif;
        font-weight: 400;
        font-style: normal;
      }
    }
    #agent-radio.form-group .bv-no-focus-ring,
    #agent-radio-working.form-group .bv-no-focus-ring {
      display: flex;
      flex-direction: row;
      .custom-radio {
        padding-right: 2em;
      }
    }

    ::-webkit-input-placeholder {
      /* Edge */
      color: #0b2340;
      opacity: 1;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #0b2340;
      opacity: 1;
    }

    ::placeholder {
      color: #0b2340;
      opacity: 1;
    }
  }
  #agent-radio label.radioOption,
  #agent-radio-working label.radioOption {
    display: none !important;
  }
  #regSubAllList label {
    display: inline-block !important;
  }
}
</style>
